

















































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import AccountDepositFixedTermValues from '@/models/Accounts/DepositAccounts/Values/AccountDepositFixedTermValues';

@Component({ name: 'AccountDepositFixedTermValuesRead' })
export default class extends SaascadaVueFieldGroup {

    @Prop({required: true })
    values: AccountDepositFixedTermValues;

}
